import Confirm from './components/Confirm';

class AlertContentTransition {
  constructor() {
    this.addListeners();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          this.addListeners();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  addListeners() {
    const search = document.querySelector('.c-Search_Form');
    const anchors = document.querySelectorAll(
      ['.st-Header a[href]:not(.st-Header_NewPost a)', '.footer a[href]', '.st-NotificationList_Item a[href]'].join(',')
    );

    anchors.forEach((anchor) => {
      if (!anchor.hasListener) {
        anchor.addEventListener('click', this.transitionConfirmation.bind(this));
        anchor.hasListener = true;
      }
    });

    if (search && !search.hasListener) {
      search.addEventListener('submit', this.transitionConfirmation.bind(this));
      search.hasListener = true;
    }
  }

  transitionConfirmation(e) {
    e.stopPropagation();
    e.preventDefault();

    const anchor = e.target.closest('a');
    const form = e.target.closest('form');
    if (!anchor && !form) return;

    // Confirm の OK ボタンは <a> なので:
    // - <a> 経由 (ログアウト等): href/method を焼けば Rails UJS が正しく送る
    //   (location.href だと GET 強制で Devise destroy_user_session が 404)
    // - <form> 経由 (ヘッダー検索): field 値を query/body に組む必要があるため
    //   form.submit() を呼ぶ
    Confirm.confirm({
      message: 'このページを離れますか？\n離れると投稿は保存されません。',
      href: anchor?.href,
      method: anchor?.dataset.method,
      remote: anchor?.dataset.remote,
      acceptCallback: e.type === 'submit' ? () => form.submit() : null,
      rejectCallback: ''
    });
  }
}

export default AlertContentTransition;
